import { PropertyValueFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";

export const fakeProperties = (
  id: string,
  date: string,
  region: string,
  montant: string
): PropertyValueFragmentFragment[] => [
  {
    property: {
      name: "id",
      mandatory: true,
      __typename: "Property",
      businessType: "String",
      code: "id",
      constraints: [],
      datatype: "String",
      confListCode: null,
    },
    value: id,
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Date de la demande",
      mandatory: true,
      __typename: "Property",
      businessType: "Timestamp",
      code: "date",
      confListCode: null,
      constraints: [
        {
          description:
            "Validates that the InputValue, if not empty, is a Timestamp prior to the present moment",
          __typename: "Constraint",
          code: "beforeNow",
          message: "La date doit être passée",
          dataType: null,
          value: null,
        },
      ],
      datatype: "Timestamp",
    },
    //"value": "2025-01-22T10:15:30.000Z",
    value: date,
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Etape",
      mandatory: false,
      __typename: "Property",
      businessType: "String",
      code: "etape",
      constraints: [],
      datatype: "String",
      confListCode: null,
    },
    value: "Décaissé creation",
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Motif du refus (updated)",
      mandatory: false,
      __typename: "Property",
      businessType: "String",
      code: "motif_refus",
      constraints: [],
      datatype: "String",
      confListCode: null,
    },
    value: "Définitif - KO Webhelp",
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Région",
      mandatory: false,
      __typename: "Property",
      businessType: "String",
      code: "region",
      constraints: [],
      datatype: "String",
      confListCode: null,
    },
    value: region,
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Date d'octroi",
      mandatory: false,
      __typename: "Property",
      businessType: "Timestamp",
      code: "date_octroi",
      constraints: [],
      datatype: "Timestamp",
      confListCode: null,
    },
    value: "2022-07-22T10:15:30.000Z",
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Date signature",
      mandatory: false,
      __typename: "Property",
      businessType: "Timestamp",
      code: "date_signature",
      constraints: [],
      datatype: "Timestamp",
      confListCode: null,
    },
    value: "2022-07-22T10:15:30.000Z",
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Montant de la demande",
      mandatory: false,
      __typename: "Property",
      businessType: "Amount",
      code: "montant_demande",
      constraints: [],
      datatype: "Float",
      confListCode: null,
    },
    value: montant,
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Date de décaissement",
      mandatory: false,
      __typename: "Property",
      businessType: "Timestamp",
      code: "date_decaissement",
      constraints: [],
      datatype: "Timestamp",
      confListCode: null,
    },
    value: "2022-07-22T10:15:30.000Z",
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Montant décaisse",
      mandatory: false,
      __typename: "Property",
      businessType: "Amount",
      code: "montant_decaisse",
      confListCode: null,
      constraints: [
        {
          description:
            "Validates that the InputValue, if not empty, is a Double equal or higher than the Constraint value",
          __typename: "Constraint",
          code: "montants",
          message: "La valeur doit être un nombre positif",
          dataType: "Float",
          value: "0.0",
        },
      ],
      datatype: "Float",
    },
    value: "75000.0",
    __typename: "PropertyValue",
  },
  {
    property: {
      name: "Type de prêt",
      mandatory: false,
      __typename: "Property",
      businessType: "String",
      code: "type_pret",
      constraints: [],
      datatype: "String",
      confListCode: null,
    },
    value: "Relance",
    __typename: "PropertyValue",
  },
];
